(function() {
  var salesEndtime = new Date;
  salesEndtime.setHours(16, 0, 0);

  function pad(num) {
    return ("0" + parseInt(num)).substr(-2);
  }
  
  function getFormattedDate(date) {
    let days = ["Jumapili", "Jumatatu", "Jumanne", "Jumatano", "Alhamisi", "Ijumaa", "Jumamosi"];
    let months = ["Januari", "Februari", "Machi", "Aprili", "Mei", "Juni", "Julai", "Agosti", "Septemba", "Oktoba", "Novemba", "Desemba"];
    formattedDate = `${days[date.getDay()]}, ${months[date.getMonth()]} ${date.getDate()}. `;
    return formattedDate;
  }
  
  function setFastestDeliveryDay() {
    var nextDelivery = "";
    var now = new Date();
    if (now.getDay() == 0) { // If Sunday, fastest delivery is +1 days
      nextDelivery = new Date();
      nextDelivery.setDate(nextDelivery.getDate() + 1);
      nextDelivery = getFormattedDate(nextDelivery);
    } else if (now.getDay() == 6 && now > salesEndtime) { // If Saturday and after salesEndtime, fastest delivery is +2 days
      nextDelivery = new Date();
      nextDelivery.setDate(nextDelivery.getDate() + 2);
      nextDelivery = getFormattedDate(nextDelivery);
    } else if (now > salesEndtime) { // If after salesEndtime, fastest delivery is tomorrow
      nextDelivery = "kesho. ";
    } else {
      nextDelivery = "leo. ";
    }
    document.getElementById('fastest-day').innerHTML = nextDelivery;
  }

  function displayTime(hh, mm, ss) {
    displayTime = ""
    if (hh == 0) {
      displayTime = mm + " mins.";
    } else {
      displayTime = hh + " hrs " + mm + " mins.";
    }
    return displayTime
  }
  
  function tick() {
    var now = new Date;
    var hourBuffer, minuteBuffer = 0;
    if (now.getDay() == 0) { // If Sunday, fastest delivery is +1 day
        salesEndtime.setDate(salesEndtime.getDate() + 1)
    } else if (now.getDay() == 6 && now > salesEndtime) { // If Saturday and after salesEndtime, fastest delivery is +2 days
      salesEndtime.setDate(salesEndtime.getDate() + 2);
    } else if (now > salesEndtime) { // If after salesEndtime, fastest delivery is +1 day
      salesEndtime.setDate(salesEndtime.getDate() + 1);
    }
    var remain = ((salesEndtime - now) / 1000);
    var hh = pad(((remain / 60 / 60) % 60));
    var mm = pad(((remain / 60) % 60));
    var ss = pad(remain % 60);
    
    document.getElementById('countdown-time').innerHTML =
      displayTime(hh, mm, ss);
    setTimeout(tick, 60000);
  }

  setFastestDeliveryDay();
  document.addEventListener('DOMContentLoaded', tick);
})();